import React from "react";
import OrderPage from "./components/OrderPage";
import { orderStatus } from "../../../constants/orderStatus";

const PreBooked = () => {
  return <OrderPage type={orderStatus.preBooked} />;
};

export default PreBooked;
